import React from "react";

const PopupMessage = ({ isOpen, message, onClose }) => {
  if (!isOpen) return null;

  return (
    <>
      <div className="popup-overlay">
        <div className="popup-box">
          <p>{message}</p>
          <button className="popup-btn" onClick={onClose}>
            OK
          </button>
        </div>
      </div>

      <style jsx>{`
        .popup-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.8); /* darker overlay */
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 2000;
        }

        .popup-box {
          background: #0c0b0bff; /* black popup background */
          color: #fff; /* white text */
          padding: 20px 30px;
          border-radius: 12px;
          box-shadow: 0px 4px 12px rgba(255, 255, 255, 0.2);
          text-align: center;
          max-width: 300px;
          animation: fadeIn 0.3s ease;
        }

        .popup-btn {
          margin-top: 15px;
          background: #007bff;
          color: white;
          padding: 8px 14px;
          border: none;
          border-radius: 8px;
          cursor: pointer;
          font-size: 14px;
        }

        .popup-btn:hover {
          background: #0056b3;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: scale(0.9);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }
      `}</style>
    </>
  );
};

export default PopupMessage;
